module.exports = __webpack_public_path__ + "static/media/team-profile-default.bd3f6125.png";